var map = {
	"./LNF/123/0.png": 72140,
	"./LNF/123/1.png": 82883,
	"./LNF/123/2.png": 41101,
	"./LNF/123/3.png": 25028,
	"./LNF/123/4.png": 61300,
	"./LNF/123/5.png": 21861,
	"./LNF/123/6.png": 44000,
	"./LNF/123/7.png": 30223,
	"./LNF/123/8.png": 39496,
	"./LNF/123/9.png": 52550,
	"./LNF/CAPITALS/A.png": 76439,
	"./LNF/CAPITALS/B.png": 10145,
	"./LNF/CAPITALS/C.png": 64109,
	"./LNF/CAPITALS/D.png": 7638,
	"./LNF/CAPITALS/E.png": 58687,
	"./LNF/CAPITALS/F.png": 45209,
	"./LNF/CAPITALS/G.png": 95871,
	"./LNF/CAPITALS/H.png": 49767,
	"./LNF/CAPITALS/I.png": 94100,
	"./LNF/CAPITALS/J.png": 71218,
	"./LNF/CAPITALS/K.png": 94026,
	"./LNF/CAPITALS/L.png": 54290,
	"./LNF/CAPITALS/M.png": 50088,
	"./LNF/CAPITALS/N.png": 32703,
	"./LNF/CAPITALS/O.png": 60613,
	"./LNF/CAPITALS/P.png": 24472,
	"./LNF/CAPITALS/Q.png": 44934,
	"./LNF/CAPITALS/R.png": 85785,
	"./LNF/CAPITALS/S.png": 79884,
	"./LNF/CAPITALS/T.png": 83729,
	"./LNF/CAPITALS/U.png": 38164,
	"./LNF/CAPITALS/V.png": 24109,
	"./LNF/CAPITALS/W.png": 49177,
	"./LNF/CAPITALS/X.png": 28990,
	"./LNF/CAPITALS/Y.png": 81826,
	"./LNF/CAPITALS/Z.png": 64178,
	"./LNF/CAPITALS/Ñ.png": 23050,
	"./LNF/lowercase/a.png": 29135,
	"./LNF/lowercase/b.png": 22850,
	"./LNF/lowercase/c.png": 14104,
	"./LNF/lowercase/d.png": 56670,
	"./LNF/lowercase/e.png": 85180,
	"./LNF/lowercase/f.png": 62033,
	"./LNF/lowercase/g.png": 17725,
	"./LNF/lowercase/h.png": 18846,
	"./LNF/lowercase/i.png": 99213,
	"./LNF/lowercase/j.png": 78626,
	"./LNF/lowercase/k.png": 88512,
	"./LNF/lowercase/l.png": 89847,
	"./LNF/lowercase/m.png": 9303,
	"./LNF/lowercase/n.png": 85507,
	"./LNF/lowercase/o.png": 19470,
	"./LNF/lowercase/p.png": 37615,
	"./LNF/lowercase/q.png": 23199,
	"./LNF/lowercase/r.png": 3577,
	"./LNF/lowercase/s.png": 9106,
	"./LNF/lowercase/t.png": 3995,
	"./LNF/lowercase/u.png": 101,
	"./LNF/lowercase/v.png": 14419,
	"./LNF/lowercase/w.png": 52809,
	"./LNF/lowercase/x.png": 92932,
	"./LNF/lowercase/y.png": 26376,
	"./LNF/lowercase/z.png": 20617,
	"./LNF/lowercase/ñ.png": 21480,
	"./WDT/123/0.png": 33797,
	"./WDT/123/1.png": 81318,
	"./WDT/123/2.png": 63363,
	"./WDT/123/3.png": 51626,
	"./WDT/123/4.png": 56626,
	"./WDT/123/5.png": 83091,
	"./WDT/123/6.png": 11335,
	"./WDT/123/7.png": 47600,
	"./WDT/123/8.png": 75754,
	"./WDT/123/9.png": 87496,
	"./WDT/CAPITALS/A.png": 94136,
	"./WDT/CAPITALS/B.png": 12389,
	"./WDT/CAPITALS/C.png": 19262,
	"./WDT/CAPITALS/D.png": 85808,
	"./WDT/CAPITALS/E.png": 88475,
	"./WDT/CAPITALS/F.png": 63034,
	"./WDT/CAPITALS/G.png": 15994,
	"./WDT/CAPITALS/H.png": 87821,
	"./WDT/CAPITALS/I.png": 43716,
	"./WDT/CAPITALS/J.png": 33695,
	"./WDT/CAPITALS/K.png": 13273,
	"./WDT/CAPITALS/L.png": 78809,
	"./WDT/CAPITALS/M.png": 11349,
	"./WDT/CAPITALS/N.png": 44393,
	"./WDT/CAPITALS/O.png": 59852,
	"./WDT/CAPITALS/P.png": 65113,
	"./WDT/CAPITALS/Q.png": 24069,
	"./WDT/CAPITALS/R.png": 36354,
	"./WDT/CAPITALS/S.png": 41524,
	"./WDT/CAPITALS/T.png": 36919,
	"./WDT/CAPITALS/U.png": 97141,
	"./WDT/CAPITALS/V.png": 72286,
	"./WDT/CAPITALS/W.png": 23088,
	"./WDT/CAPITALS/X.png": 95719,
	"./WDT/CAPITALS/Y.png": 88087,
	"./WDT/CAPITALS/Z.png": 33139,
	"./WDT/lowercase/a.png": 97653,
	"./WDT/lowercase/b.png": 77399,
	"./WDT/lowercase/c.png": 57862,
	"./WDT/lowercase/d.png": 47397,
	"./WDT/lowercase/e.png": 72051,
	"./WDT/lowercase/f.png": 43899,
	"./WDT/lowercase/g.png": 63192,
	"./WDT/lowercase/h.png": 23523,
	"./WDT/lowercase/i.png": 12825,
	"./WDT/lowercase/j.png": 94413,
	"./WDT/lowercase/k.png": 64416,
	"./WDT/lowercase/l.png": 22465,
	"./WDT/lowercase/m.png": 80658,
	"./WDT/lowercase/n.png": 85830,
	"./WDT/lowercase/o.png": 17723,
	"./WDT/lowercase/p.png": 20685,
	"./WDT/lowercase/q.png": 71099,
	"./WDT/lowercase/r.png": 15345,
	"./WDT/lowercase/s.png": 74969,
	"./WDT/lowercase/t.png": 56659,
	"./WDT/lowercase/u.png": 32497,
	"./WDT/lowercase/v.png": 57590,
	"./WDT/lowercase/w.png": 28275,
	"./WDT/lowercase/x.png": 76747,
	"./WDT/lowercase/y.png": 59005,
	"./WDT/lowercase/z.png": 90388,
	"./WoodPieces/CAPITALS/A.png": 69652,
	"./WoodPieces/CAPITALS/B.png": 1258,
	"./WoodPieces/CAPITALS/C.png": 52260,
	"./WoodPieces/CAPITALS/D.png": 7499,
	"./WoodPieces/CAPITALS/E.png": 47180,
	"./WoodPieces/CAPITALS/F.png": 56936,
	"./WoodPieces/CAPITALS/G.png": 41374,
	"./WoodPieces/CAPITALS/H.png": 71783,
	"./WoodPieces/CAPITALS/I.png": 88109,
	"./WoodPieces/CAPITALS/J.png": 6919,
	"./WoodPieces/CAPITALS/K.png": 87807,
	"./WoodPieces/CAPITALS/L.png": 33918,
	"./WoodPieces/CAPITALS/M.png": 42405,
	"./WoodPieces/CAPITALS/N.png": 70448,
	"./WoodPieces/CAPITALS/O.png": 27959,
	"./WoodPieces/CAPITALS/P.png": 71867,
	"./WoodPieces/CAPITALS/Q.png": 41723,
	"./WoodPieces/CAPITALS/R.png": 12056,
	"./WoodPieces/CAPITALS/S.png": 74077,
	"./WoodPieces/CAPITALS/T.png": 17372,
	"./WoodPieces/CAPITALS/U.png": 72798,
	"./WoodPieces/CAPITALS/V.png": 83624,
	"./WoodPieces/CAPITALS/W.png": 53927,
	"./WoodPieces/CAPITALS/X.png": 4269,
	"./WoodPieces/CAPITALS/Y.png": 83252,
	"./WoodPieces/CAPITALS/Z.png": 9582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25144;